<template>
    <div :class="['container-map','container']">
        <div>
            <!-- preview list in mobile -->
            <div v-if="this.isMobile">
                <div v-for="(hotspot,index) in hotspots"  :key="index">
                    <a href="https://iusful.com/" target="_blank">
                    <div  :class="['hotspot',{hide: hotspot.hideMobile}]" v-if="index<=2">
                        <div v-bind:style="{ top: hotspot.posX + '%',left: hotspot.posY + '%' }">
                            <span class="dot"></span>
                            <h1>{{hotspot.name}}</h1>
                            <p>{{hotspot.city}}</p>
                        </div>
                    </div>
                    </a>
                </div>
            </div>
     
            <div :class="isMobile == true ? 'collapse' : 'notCollapse'" id="collapseExample">
                            
            <!-- lista completa desktop -->
            <div v-if="this.isMobile==false">
                <div v-for="(hotspot,index) in hotspots"  :key="index">
                    <div :class="[hotspot.city,'hotspot']">
                        <div v-bind:style="{ top: hotspot.posX + '%',left: hotspot.posY + '%' }">
                            <span class="dot"></span>
                            <h1>{{hotspot.name}}</h1>
                            <p>{{hotspot.city}}</p>
                        </div>
                    </div>
                </div>
            </div>
            <!-- lista senza preview (vedi sopra) mobile -->
            <div v-else>
                <div v-for="(hotspot,index) in hotspots"  :key="index">
                    <a href="https://iusful.com/" target="_blank">
                    <div :class="['hotspot',{hide: hotspot.hideMobile}]" v-if="index>=3">
                        <div v-bind:style="{ top: hotspot.posX + '%',left: hotspot.posY + '%' }">
                            <span class="dot"></span>
                            <h1>{{hotspot.name}}</h1>
                            <p>{{hotspot.city}}</p>
                        </div>
                    </div>
                    </a>
                </div>
            </div>
            
            <img src="../assets/network-map.png" alt="">
        </div>
        <a class="read-more" data-toggle="collapse" href="#collapseExample" role="button" aria-expanded="false" aria-controls="collapseExample">
         vedi tutti
        </a>
        </div>
    </div>
</template>

<script>
export default {
    name:'map-network',
    data:()=>{
        return {
            isMobile:false,
            hotspots:[
                {
                    id:1,
                    name:"Rabotlaw",
                    city:"Belgium",
                    posX:"26",
                    posY:"44",
                },
                {
                    id:2,
                    name:"Shopova, Kolarova and Partners Law Association",
                    city:"Bulgaria",
                    posX:"36",
                    posY:"64"
                },
                {
                    id:3,
                    name:" Law Firm Vedriš & Partners",
                    city:"Croatia",
                    posX:"33",
                    posY:"54"
                },
                {
                    id:4,
                    name:"Typographos & Co. Lawyers",
                    city:"Cyprus",
                    posX:"45",
                    posY:"64"
                },
                {
                    id:5,
                    name:"Brezina Marik & Partneri",
                    city:"Czech republic",
                    posX:"27",
                    posY:"53"
                },
                {
                    id:6,
                    name:"Advokatcentret",
                    city:"Denmark",
                    posX:"19",
                    posY:"48"
                },
                {
                    id:7,
                    name:"Elysées Law",
                    city:"France",
                    posX:"29",
                    posY:"40"
                },
                {
                    id:8,
                    name:"Meincke Bienmüller Rechtsanwälte",
                    city:"Germany",
                    posX:"23",
                    posY:"47"
                },
                {
                    id:9,
                    name:"CREON Anwaltskanzlei",
                    city:"Germany",
                    posX:"24",
                    posY:"51"
                },
                {
                    id:10,
                    name:"Lengyel & Tóth B. Legal Association",
                    city:"Hungary",
                    posX:"30",
                    posY:"57"
                },
                {
                    id:11,
                    name:"Tudor Nicolaou",
                    city:"Italy",
                    posX:"32",
                    posY:"52",
                   
                },
                {
                    id:12,
                    name:"Tudor Nicolaou",
                    city:"Italy",
                    posX:"36.5",
                    posY:"51",
                    hideMobile:true,
                },
                {
                    id:13,
                    name:"DIMITRIJEVIĆ LAW OFFICE",
                    city:"Macedonia",
                    posX:"37",
                    posY:"61"
                },
                {
                    id:14,
                    name:"ADRIAANSE VAN DER WEEL ADVOCATEN",
                    city:"Netherland",
                    posX:"24",
                    posY:"44"
                },
                {
                    id:16,
                    name:"Jakubowski Pluta i Wspólnicy",
                    city:"Poland",
                    posX:"24",
                    posY:"60"
                },
                {
                    id:16,
                    name:"Stanišić Law Office",
                    city:"Serbia",
                    posX:"33",
                    posY:"59.3"
                },
                {
                    id:17,
                    name:"Valko Marián & Partners",
                    city:"Slovakia",
                    posX:"29",
                    posY:"56"
                },
                {
                    id:18,
                    name:"Law firm Čad",
                    city:"Slovenia",
                    posX:"31.5",
                    posY:"53"
                },
                {
                    id:19,
                    name:"Addvante Economistas & Abogados",
                    city:"Spain",
                    posX:"37",
                    posY:"40"
                },
                {
                    id:20,
                    name:"CH. Hausmann & Co. Solicitors",
                    city:"United kingdom",
                    posX:"24",
                    posY:"39"
                },
                {
                    id:21,
                    name:"Tudor Nicolaou",
                    city:"Italy",
                    posX:"31.5",
                    posY:"51",
                    hideMobile:true,
                },
            ]
        }
    },
    mounted(){
        if(window.innerWidth<992) this.isMobile=true
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

.read-more {
    display: none;
}

    .container-map {
        position: absolute;
        width: 100%;
        overflow: hidden;
        top: 0;
        height: 100%;
        background: #E3E3E3;
        z-index: 0;
        padding: 0;
        z-index: 0;
        &>div{
            position: relative;
        }
        img {
            display: block;
            width: 100%;
            max-width: 100%;
            height: auto;
            margin-top: 0%;
        }
    }

.hotspot >div{
    position: absolute;
    z-index: 9;
    .dot {
    width: 10px;
    height: 10px;
    display: block;
    margin-left: 5px;
    cursor: pointer;

      
        left: 50%;
        top:50%;
        position: relative;
        transform: translate(-50%,-50%);
        &:before{
            background: #1B1B19;
            width: 6px;
            height: 6px;
            display: block;
            content: "";
            border-radius: 6px;
            -webkit-transform: translate(-50%, -50%);
            transform: translate(-50%, -50%);
            position: absolute;
            top: 50%;
            left: 50%;
        }
        &:after {
                transition: 0.3s ease-out;

            content: "";
            position: absolute;
            background: transparent;
            border: 1px solid #fff;
            width: 30px;
            height: 30px;
            left: 50%;
            top:50%;
            transform: translate(-50%,-50%) scale3d(0,0,0);
            display: block;
            border-radius: 50px;

        }
    }
    h1,p {
        position: absolute;
        top: -27px;
        right: -40px;
        width: 100%;
        white-space: nowrap;
        line-height: 1.5rem;
        transform: translate3d(0,20px,0);
        transition: 0.3s ease-out;
        pointer-events: none;
        color: #333;
        text-decoration: none;
    }
    h1 {
        opacity: 0;

        font-size: 1rem;
        margin:0 ;
    }
    p{  
        opacity: 0;
        top: -5px;
        color: #fff;
        font-size: 0.75rem;
        text-transform: uppercase;

    }
}
.hotspot.Italy >div .dot{
    &:before{
        width: 8px;
        height: 8px;
        background: #F04533;
    }
}
.hotspot  {

       .dot:hover {
            &:after {
                transition: 0.3s ease-out;
                transform: translate(-50%,-50%) scale3d(1,1,1);
            }
       }
       .dot:hover+h1 {
            opacity: 1;
            transition: 0.3s ease-out;
            transform: translate3d(0,0,0);

    }
    .dot:hover+h1+p{  
        opacity: 1;
        transform: translate3d(0,0,0);
        transition: 0.2s ease-out;
        transition-delay: 0.2s;

    }
}
.hide{
    display: none;
}
@media (min-width: 992px){

    .container-map {
        max-width: none;
        }
    }
@media (max-width: 992px){
    .read-more {
        display: block;
    }
    .section.network {
    height: auto;

}
    .container-map {
        position: relative;
        padding: 0 15px;
        background-color: transparent;
         img {
            display: none;
        }
    }
    .hotspot >div{
        top: 0!important;
        left: 0 !important;
        position: relative;
        z-index: 9;
        width: auto;
        height: auto;
        border-bottom: 1px solid rgba(0, 0, 0, 0.198);
        padding: 18px 0px;
        .dot {
            display: none;
        }
            h1,p {
                white-space:normal;
                                margin: 0;
                top: 0;
                left: 0;
                position: relative;
                transform: translate(0,0);
                opacity: 1;
            }
            p {
                color: #4c3f3f;
            }
    }
}
@media (max-width: 768px) {
    .hotspot > div{
        padding: 9px 0px;
    }
    .hotspot > div h1{
        line-height: 1rem;
        font-size: 0.875rem;
    }
    .read-more{
        margin-top: 1rem;
    }
}
</style>
